<template>
    <MainHeader/>
    <HeroSection/>
    <Events/>
    <Course/>
    <Blog/>
    <!-- <FreeEducation/> -->
    <Footer footerPadding="true"/>
</template>

<script>
import MainHeader from '../components/Home/Header.vue';
import HeroSection from '../components/Home/HeroSection.vue';
import Events from '../components/Home/Events.vue';
import Course from '../components/Home/Course.vue';
import Blog from '../components/Home/Blog.vue';
// import FreeEducation from '../components/Home/FreeEducation.vue';
import Footer from '../components/Home/Footer.vue';
import { useSeo } from '@/composables/useSeo';

export default {
    name:'HomePage',
    components:{
        MainHeader,
        HeroSection,
        Events,
        Course,
        Blog,
        // FreeEducation,
        Footer,
    },
    setup() {
        useSeo({
            title: 'Online Psikoloji ve Kişisel Gelişim Eğitimleri',
            description: 'Prof. Dr. Hakan Türkçapar, Prof. Dr. Kemal Sayar, Prof. Dr. Mücahit Öztürk, Prof. Dr. Vahdet Görmez, Prof. Dr. Erol Göka, Dr. Aslıhan Dönmez ve Hanna Nita Scherler ile online psikoloji, aile, evlilik, kaygı ve ebeveynlik eğitimleri.',
            url: '/',
            type: 'website'
        })
    }
}
</script>